import React, { useRef } from 'react';
import { ChannelVideo } from '@/typings/channelVideo';
import * as S from './ChannelVideoDetail.styles';
import ChannelVideoCard from '@/components/ChannelVideoCard/ChannelVideoCard';
import { Divider } from '@mantine/core';
import { Variants, motion } from 'framer-motion';
import { ChannelVideoCarousel, ChannelVideoCarouselSlide } from '../Home/Home.styles';

type ChannelVideoDetailProps = {
  video: ChannelVideo;
  relatedVideos: ChannelVideo[];
};

const ChannelVideoDetail: React.FC<ChannelVideoDetailProps> = ({ video, relatedVideos }) => {
  const scrollRef = useRef(null);
  const itemMotion: Variants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      transition: {
        mass: 1,
        duration: 0.6,
        type: 'tween',
      },
      opacity: [0, 0.2, 0.3, 0.5, 1],
      y: 0,
      height: '100%',
    },
  };

  return (
    <S.Wrapper vertical={video.verticalVideo}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: {
            mass: 1,
            delay: 0.2,
            duration: 0.6,
            type: 'tween',
          },
        }}
      >
        <ChannelVideoCard
          {...video}
          gradientColor={video.category?.color}
          title={undefined}
          shouldOpenModalOnClick
        />
        {video.title && <h1>{video.title}</h1>}
        {video.description && (
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: video.description }} />
        )}
        {relatedVideos.length > 0 && (
          <>
            <Divider color="#C1C2C5" />
            <S.RelatedVideosSection videosLength={relatedVideos.length}>
              <h2>Vídeos Relacionados</h2>

              <ChannelVideoCarousel
                slideSize="50%"
                slideGap={30}
                mx="auto"
                w="100%"
                align="start"
                controlsOffset={-20}
                breakpoints={[
                  { maxWidth: 'md', slideSize: '50%' },
                  { maxWidth: 'sm', slideSize: '100%', slideGap: 0 },
                ]}
                controlSize={32}
                styles={{
                  viewport: {
                    padding: '20px 0',
                  },
                }}
              >
                {relatedVideos?.map((video) => (
                  <ChannelVideoCarouselSlide key={video.id}>
                    <motion.div variants={itemMotion} viewport={{ root: scrollRef }}>
                      <ChannelVideoCard
                        {...video}
                        gradientColor={video.category?.color}
                        disableVertical={true}
                      />
                    </motion.div>
                  </ChannelVideoCarouselSlide>
                ))}
              </ChannelVideoCarousel>
            </S.RelatedVideosSection>
          </>
        )}
      </motion.div>
    </S.Wrapper>
  );
};

export default ChannelVideoDetail;
